import React from 'react';
import Edit from '../../rest/Edit';
import Form from '../components/Form';

const SalaryHistoriesEdit = props => (
  <Edit {...props} resource="salaryHistories">
    <Form />
  </Edit>
);

SalaryHistoriesEdit.propTypes = {};

export default SalaryHistoriesEdit;
